<div class="content-container mx-auto my-4">
    <h1 class="mt-0">{{ node.pageTitle || 'Find the right permit' }}</h1>
    <p class="text-muted">{{ node.intro || 'Answer a couple of quick questions and we’ll point you to the right application.' }}</p>
    @if (node.introBullets) {
        <ul class="text-muted small">
            @for (point of node.introBullets; track point) {
                <li>{{ point }}</li>
            }
        </ul>
    }

    @if (node.kind === 'question') {
        <div class="finder-card">
            @if (node.question) {
                <h2 class="h5">{{ node.question }}</h2>
            }
            @if (node.hint) {
                <p class="text-muted small">{{ node.hint }}</p>
            }

            <div class="d-flex flex-column gap-2 mt-3">
                @for (opt of node.options; track opt.label) {
                    <button type="button" class="btn finder-option ms-0" (click)="select(opt)">
                        <span>{{ opt.label }}</span>
                        <i class="fa fa-chevron-right finder-option__chevron" aria-hidden="true"></i>
                    </button>
                }
            </div>
        </div>
    } @else {
        <div class="finder-card">
            <h2 class="h5">{{ node.title }}</h2>
            <p class="mb-2">{{ node.body }}</p>

            @if (node.note) {
                <div class="alert alert-info" role="alert">{{ node.note }}</div>
            }

            @if (node.route) {
                <button type="button" class="btn btn-primary ms-0 mt-2" (click)="go(node.route)">{{ node.buttonLabel || 'Continue' }}</button>
            }
        </div>
    }

    <div class="d-flex gap-3 mt-3">
        @if (canGoBack) {
            <button type="button" class="btn btn-link ps-0" (click)="back()"><i class="fa fa-arrow-left me-1"></i> Back</button>
        }
        @if (currentId) {
            <button type="button" class="btn btn-link" (click)="restart()">Start over</button>
        }
    </div>
</div>
